import { render, staticRenderFns } from "./TopicsIndex.vue?vue&type=template&id=50fca04e"
import script from "./TopicsIndex.vue?vue&type=script&lang=js"
export * from "./TopicsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports